var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cv-number-input",class:`${_vm.carbonPrefix}--form-item`},[_c('label',{class:`${_vm.carbonPrefix}--label ${_vm.carbonPrefix}--skeleton`}),_c('div',{class:`${_vm.carbonPrefix}--number ${_vm.carbonPrefix}--skeleton`})])
}
var staticRenderFns = []

export { render, staticRenderFns }